import _, { isObject } from 'lodash';
import { UpdateTypes } from '@/common/service/checkout-utils';
import { planTypes, BASE_PLAN_SUB_TYPES, AUDIO_SUB_TYPES } from '@/common/constants';
import { computedPbxBasePlans, computedPbxCallingPlans } from '@/common/service/computers/plans/pbx';
import {
  isOnlineNotSupportPlan,
  ONLINE_NOT_SUPPORT_BILLING_CYCLE,
} from '@/common/service/non-standard-billing-cycle-utils';

import { getBasePlanInfo } from '@/common/product';
import { getMeetingPlanByCategory } from '@/plans/ZOOM_MEETING/common/utils';
import { translation } from '../plugins/i18n';
import { getPartnershipParams } from '@/views/config/partner-refer/helper/params';
import { pickMinimalTypes } from '@/common/utils';
import { addToCart } from '@/common/service/flow/utils';

// edu school => edu school plus
export const getEdu2EduPlusUpdateForm = (getters) => {
  const actionType = UpdateTypes.EDU_SCH_CMP_UPGRADE;

  const boughtMeetingCategory = _.chain(getters.boughtPlans)
    .find((p) => p.type === planTypes.ZOOM_MEETING)
    .get('category')
    .value();

  const eduPlan = getMeetingPlanByCategory(getters.boughtPlans, boughtMeetingCategory);
  const pbxBasePlans = computedPbxBasePlans(getters.boughtPlans);
  const planList = getters.getSelectedPlans
    .filter((p) => {
      if (pbxBasePlans.length && p.type === planTypes.ZOOM_PHONE) {
        return false;
      }
      return true;
    })
    .map((p) => {
      const extraKeys = {};
      if (
        p.type !== planTypes.ZOOM_PHONE &&
        (ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(p.billing_cycle) ||
          ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(eduPlan.billing_cycle))
      ) {
        Object.assign(extraKeys, { planType: p.plan_type, oldPlanType: eduPlan.plan_type });
      }
      return {
        oldPlanCode: p.type === planTypes.ZOOM_PHONE ? '' : eduPlan.plan_code,
        quantity: p.cartInfo.selected_number,
        planCode: p.plan_code,
        ...extraKeys,
      };
    });
  return { planList, actionType };
};

// edu annual -> edu school
export const getEdu2EscUpdateForm = (getters) => {
  let actionType;
  const boughtMeetingCategory = _.chain(getters.boughtPlans)
    .find((p) => p.type === planTypes.ZOOM_MEETING)
    .get('category')
    .value();

  const pbxBasePlans = computedPbxBasePlans(getters.boughtPlans);
  const eduPlan = getMeetingPlanByCategory(getters.boughtPlans, boughtMeetingCategory);
  const planList = getters.getSelectedPlans
      .filter((p) => {
        if (pbxBasePlans.length && p.type === planTypes.ZOOM_PHONE) {
          return false;
        }
        return true;
      })
    .map((p) => {
      const extraKeys = {};
      if (
        p.type !== planTypes.ZOOM_PHONE &&
        (ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(p.billing_cycle) ||
          ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(eduPlan.billing_cycle))
      ) {
        Object.assign(extraKeys, { planType: p.plan_type, oldPlanType: eduPlan.plan_type });
      }
      if (p.type !== planTypes.ZOOM_PHONE){
        actionType = p.type === planTypes.ZONE_EDU_PLUS ? UpdateTypes.EDU_SCH_CMP_UPGRADE : UpdateTypes.EDU_ANNUAL_TO_SCH_CMP;
      }
      return {
        oldPlanCode: p.type === planTypes.ZOOM_PHONE ? '' :
          p.type === planTypes.TOLLFREE ? p.plan_code : eduPlan.plan_code,
        quantity: p.cartInfo.selected_number,
        planCode: p.plan_code,
        ...extraKeys,
      };
    });
  return { planList, actionType };
};

export const getMeeting2BizPlusUpdateForm = (getters) => {
  const actionType = UpdateTypes.MEETING_TO_BIZ_PLUS;

  const boughtMeetingCategory = _.chain(getters.boughtPlans)
    .find((p) => p.type === planTypes.ZOOM_MEETING)
    .get('category')
    .value();

  const bizPlan = getMeetingPlanByCategory(getters.boughtPlans, boughtMeetingCategory);
  // if has zp base plan, filter zp base plan
  const pbxBasePlans = computedPbxBasePlans(getters.boughtPlans);
  // no op free trail plan
  const planList = getters.getSelectedPlans
    .filter((p) => {
      if (pbxBasePlans.length && p.type === planTypes.ZOOM_PHONE) {
        return false;
      }
      return true;
    })
    .filter(payload => !payload.isVendorProduct)
    .map((p) => {
      const extraKeys = {};
      if (
        p.type !== planTypes.ZOOM_PHONE &&
        (ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(p.billing_cycle) ||
          ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(bizPlan.billing_cycle))
      ) {
        Object.assign(extraKeys, { planType: p.plan_type, oldPlanType: bizPlan.plan_type });
      }
      return {
        oldPlanCode: p.type === planTypes.ZOOM_PHONE ? '' : bizPlan.plan_code,
        quantity: p.cartInfo.selected_number,
        planCode: p.plan_code,
        ...extraKeys,
      };
    });
  const partnerReferParams = getPartnershipParams();
  return { planList, actionType, extensionUpdateData: { ...partnerReferParams } };
};

export function getPro2ProPlusUpdateForm(getters) {
  const actionType = UpdateTypes.PRO_TO_PTO_PLUS;
  const pro = getMeetingPlanByCategory(getters.boughtPlans, BASE_PLAN_SUB_TYPES.PRO);
  let planList = getters.getSelectedPlans
    .filter(payload => !payload.isVendorProduct)
    .map((p) => {
      let oldPlanCode = '';
      if (p.type === planTypes.ZONE_PRO_PLUS) {
        oldPlanCode = pro.plan_code;
      }
      const extraKeys = {};
      if (
        p.type !== planTypes.ZOOM_PHONE &&
        (ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(p.billing_cycle) ||
          ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(pro.billing_cycle))
      ) {
        Object.assign(extraKeys, { planType: p.plan_type, oldPlanType: pro.plan_type });
      }
      return {
        oldPlanCode,
        planCode: p.plan_code,
        quantity: p.cartInfo.selected_number,
        ...extraKeys,
      };
    })
    .filter((p) => {
      const isBought = getters.boughtPlans.find((_p) => _p.plan_code === p.planCode);
      if (isBought) {
        return false;
      }
      return p;
    });
  const partnerReferParams = getPartnershipParams();

  return {
    actionType,
    planList,
    extensionUpdateData: {
      ...partnerReferParams
    }
  };
}

export function getProPlus2BizPlusUpdateForm(getters) {
  const bizplus = getters.getSelectedPlans.find((p) => p.type === planTypes.ZOOM_ONE_BUNDLE);
  const prop = getters.boughtPlans.find((p) => p.type === planTypes.ZONE_PRO_PLUS);
  const extraKeys = {};
  if (
    ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(prop.billing_cycle) ||
    ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(bizplus.billing_cycle)
  ) {
    Object.assign(extraKeys, { planType: bizplus.plan_type, oldPlanType: prop.plan_type });
  }
  return {
    actionType: UpdateTypes.PRO_PLUS_TO_PRO_PLUS,
    planList: [
      {
        oldPlanCode: prop.plan_code,
        planCode: bizplus.plan_code,
        quantity: bizplus.cartInfo.selected_number,
        ...extraKeys,
      },
    ],
  };
}

export const checkAudioChange = (getters, form) => {
  const selectedAudioPlan = getters.getSelectedPlans.find(
    (item) => item.type === planTypes.TOLLFREE && item.category === AUDIO_SUB_TYPES.UNLIMITED,
  );
  if (selectedAudioPlan && form.planList.every((p) => p.planCode !== selectedAudioPlan.plan_code)) {
    const extraKeys = {};
    if (
      isOnlineNotSupportPlan({
        planType: selectedAudioPlan.type,
        billingCycle: selectedAudioPlan.billing_cycle,
        category: selectedAudioPlan.category,
      })
    ) {
      Object.assign(extraKeys, { planType: selectedAudioPlan.plan_type, oldPlanType: selectedAudioPlan.plan_type });
    }
    form.planList.push({
      quantity: selectedAudioPlan.cartInfo.selected_number,
      planCode: selectedAudioPlan.plan_code,
      oldPlanCode: selectedAudioPlan.plan_code,
      ...extraKeys,
    });
  }
  return form;
};

const getEstimateTax = (getters) => {
  const { getTaxTotalAmount, getProratedChargeTaxAmount, isProrated } = getters;
  if (!isProrated && !window?.$context?.is?.delta) {
    return getTaxTotalAmount;
  }
  return getProratedChargeTaxAmount;
};

const getTranslationMap = (attributeName) => {
  const elements = document.querySelectorAll(`[${attributeName}]`);
  const map = new Map();
  elements?.forEach((element) => {
    const key = element.getAttribute(attributeName);
    const value = element.value || element.textContent;
    if (key && value !== '') {
      map.set(key, value);
    }
  });
  return map;
};

export const getOrderSummaryFields = (getters) => {
  const { getSelectedPlansMap } = getters;

  if (!isObject(getSelectedPlansMap)) {
    return {};
  }

  const titleTranslationsMap = getTranslationMap('data-plan-code-title');
  const categoryTranslationMap = getTranslationMap('data-parent-category-title');
  const planNameMap = Object.entries(getSelectedPlansMap).reduce((acc, [key, value]) => {
    // For ZP AIC prepaid minute tiers, UI plan code may be decorated like "<base>$<minutes>".
    // Order summary payload should use base planCode as key (same as planList.planCode).
    let normalizedKey = key;
    if (
      value?.type === planTypes.ZOOM_PHONE$AICONCIERGE &&
      typeof key === 'string' &&
      key.includes('$') &&
      key.startsWith('zp_ai_concierge_')
    ) {
      normalizedKey = key.split('$')[0];
    }

    let currentValue = titleTranslationsMap.get(key) || titleTranslationsMap.get(normalizedKey);
    if (!currentValue) {
      currentValue = value?.planNameKey ? translation(value?.planNameKey) : '';
    }
    return {
      ...acc,
      [normalizedKey]: currentValue,
    };
  }, {});
  const estimateTax = getEstimateTax(getters);

  const result = {
    planNameMap,
    planCategoryMap: Object.fromEntries(categoryTranslationMap),
    estimateTax,
  };

  return result;
};

export function getDowngradeToProPlusForm(getters) {
  const selectedPlans = getters.getSelectedPlans;
  const boughtPlans = getters.boughtPlans
  const { planType, plans } = getBasePlanInfo(getters.boughtPlans);

  const planList = selectedPlans
  .filter((p) => {
    const isBought = getters.boughtPlans.find((_p) => _p.plan_code === p.plan_code);
    if (isBought) {
      return false;
    }
    return p;
  }).map((item, idx) => {
    if (item.type === planTypes.ZONE_PRO_PLUS && plans[idx]) {
      return {
        quantity: item.cartInfo.selected_number,
        planCode: item.plan_code,
        oldPlanCode: plans[idx].plan_code,
      };
    }
    return {
      quantity: item.cartInfo.selected_number,
      planCode: item.plan_code,
    };
  });

  if (planType === planTypes.ZOOM_MEETING) {
    return {
      planList,
      actionType: UpdateTypes.PRO_TO_PTO_PLUS,
    };
  } else if (planType === planTypes.ZOOM_ONE_BUNDLE) {
    let actionType = UpdateTypes.BIZ_PLUS_TO_BIZ
    if (
      !_.some(boughtPlans, (plan) => plan.type === planTypes.LARGE_MEETING) &&
      _.some(selectedPlans, (plan => plan.type === planTypes.LARGE_MEETING))
    ) {
      actionType = UpdateTypes.SWITCH
    }
    return {
      planList,
      actionType,
    };
  }
  return null;
}

export const checkDependentCallingPlan = (boughtPlans = []) => (planMapFlat) => {
  const selectedPlans = planMapFlat.filter(p => p.cartInfo?.selected_number > 0);
  const pbxAddonPlans = selectedPlans
  .filter(p => p.dependCallingTypes && p.dependCallingTypes.length > 0);

  const needAddDepPlans = pbxAddonPlans.filter(p => (
    !selectedPlans.some(sp => p.dependCallingTypes?.includes(sp.pbx_sub_type)) && 
    !boughtPlans.some(bp => p.dependCallingTypes?.includes(bp.pbx_sub_type))
  ));

  if (needAddDepPlans.length === 0) return planMapFlat;

  const defaultCycle = needAddDepPlans[0].billing_cycle;

  const pbxAddonDeps = needAddDepPlans
  .map(p => p.dependCallingTypes);

  const minimalTypes = pickMinimalTypes(pbxAddonDeps)

  const unselectedTypes = minimalTypes.filter(t => !selectedPlans.some(p => p.pbx_sub_type === t) && !boughtPlans.some(p => p.pbx_sub_type === t));

  const selectedCallingRegions = _.uniq(
    computedPbxCallingPlans(selectedPlans)
      .map(p => p.region)
      .filter(Boolean),
  );

  unselectedTypes.forEach(t => {
    const plan = planMapFlat.find(p => (
      p.type === planTypes.ZOOM_PHONE && 
      p.billing_cycle === defaultCycle && 
      p.pbx_sub_type === t && 
      (selectedCallingRegions.length === 0 || selectedCallingRegions.includes(p.region))
    ));
    if (plan) {
      addToCart(plan, 1);
    }
  });
  return planMapFlat;
};
